import { defineStore } from 'pinia'
import { useChatbotStore } from '.'
import { chatbotApi } from '@/helpers/api'

export const useChatbotSurveyStore = defineStore('ChatbotSurvey', () => {
  const chatbotStore = useChatbotStore()

  let chatData = {}

  const saveChatData = () => {
    chatData = {
      chat_id: chatbotStore.chatId,
      messages: chatbotStore.chatApiRequestMessages,
    }
    chatbotStore.refreshSession()
  }

  const submitSurvey = (survey: { thumb?: string; feedback?: string }) => {
    const data = {
      ...chatData,
      survey,
    }
    chatbotApi.post('/survey', data)
  }

  return {
    saveChatData,
    submitSurvey,
  }
})
